import { Injectable } from '@angular/core';
import {
  Notification,
  StateFacade as SharedStateFacade
} from '@com-delta-idp/mnx-skymiles-shared';
import { Store, select } from '@ngrx/store';
import { ReplaySubject, Subject } from 'rxjs';
import * as actions from '../+state/actions/landing-page.actions';
import * as selectors from '../+state/selectors/landing-page.selectors';

@Injectable({
  providedIn: 'root'
})
export class StateFacade {
  loaded$ = this.store.pipe(select(selectors.getLandingPageLoaded));
  medallionBanner$ = this.store.pipe(select(selectors.getMedallionBanner));
  menu$ = this.store.pipe(select(selectors.getMenu));
  menuData$ = this.store.pipe(select(selectors.getMenuData));
  baseContentError$ = this.store.pipe(select(selectors.getBaseContentError));
  notification$ = new ReplaySubject<Notification>(1, 8000);
  selectedNotificationTab$ = new Subject<number>();

  constructor(
    private readonly store: Store,
    private readonly sharedState: SharedStateFacade
  ) {}

  init() {
    this.sharedState.init();
    this.store.dispatch(actions.loadAEMMedallionBanner());
    this.store.dispatch(actions.loadAEMMenu());
    this.store.dispatch(actions.loadAEMFeatureFlags());
    this.store.dispatch(actions.loadAEMErrorMessages());
    this.store.dispatch(actions.loadBusinessTravelerFeatureFlagContent());
  }

  triggerMenu() {
    this.menuData$.subscribe((content) => {
      this.store.dispatch(
        actions.loadAEMMenuSuccess({
          aemMenuContent: {
            id: 'aem-menu',
            aemMenu: content
          }
        })
      );
    });
  }
}
